import findInboxInHistory from './find_inbox_in_history';
import Inbox from 'models/location/inbox';

export default function(context) {
  let currentLocation = context.stores.currentLocation.get();
  return (currentLocation instanceof Inbox && currentLocation) || findInboxInHistory(context) || Inbox.create();
}
